import { useContext } from 'react';
import PropTypes from 'prop-types';

// Import context
import { ShakaPlayerTvContext } from './player_tv/ShakaPlayerTvProvider';
import { ShakaPlayerContext } from 'components/context/player/player_vod';

// Import variables
import { PLAYER_SELECTORS } from 'helpers/variables';

const usePlayerContext = ({ type }) => {
	const isVodPlayer = type === PLAYER_SELECTORS.VOD;

	const context = useContext(
		isVodPlayer ? ShakaPlayerContext : ShakaPlayerTvContext
	);

	return context;
};

usePlayerContext.propTypes = {
	type: PropTypes.string.isRequired
};

export default usePlayerContext;
